import { CALYPSO_LIGHT, CALYPSO_MEDIUM } from 'HubStyleTokens/colors';
import { createContext } from 'react';
import { AGENT, DEFAULT, VISITOR } from '../../../constants/messageUses';
import Theme from '../../../primary-message/records/Theme';
export const defaultThemeConfig = {
  [DEFAULT]: Theme(),
  [AGENT]: Theme(),
  [VISITOR]: Theme({
    backgroundColor: CALYPSO_LIGHT,
    borderColor: CALYPSO_MEDIUM
  })
};

/**
 * Uses a configuration file (or the default) containing a mapping of message uses to their
 * respective themes. Since a theme record sets values for every field by default, consumers of a
 * theme will always have a value to choose from.
 */
const ThemeConfigContext = /*#__PURE__*/createContext(defaultThemeConfig);
export default ThemeConfigContext;